
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Strategic Advisory',
      description: 'Navigate complex markets and regulatory landscapes with deep private and public sector networks',
      features: [
        'Market entry strategy and feasibility studies',
        'Regulatory and compliance navigation',
        'Stakeholder engagement and relationship management',
        'Risk assessment and mitigation planning',
        'Government relations and policy advocacy'
      ]
    },
    {
      icon: 'ri-team-line',
      title: 'Development Counseling',
      description: 'Guide multilaterals and development agencies through feasibility studies and project structuring',
      features: [
        'Project feasibility and impact assessment',
        'Funding strategy and capital structuring',
        'Development program design',
        'Multi-stakeholder coordination',
        'ESG compliance and reporting frameworks'
      ]
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Equity Participations',
      description: 'Active project development with financial structuring, funding, and strategic equity stakes',
      features: [
        'Co-investment and joint venture structuring',
        'Financial modelling and valuation',
        'Capital raising and investor relations',
        'Portfolio management and value creation',
        'Exit strategy planning and execution'
      ]
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light mb-6" style={{ color: '#607a7a' }}>
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive advisory solutions designed to drive sustainable growth and create lasting impact across sectors
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gradient-to-br from-slate-50 to-blue-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 group">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" style={{ backgroundColor: '#98b8c1' }}>
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-medium mb-4" style={{ color: '#607a7a' }}>
                {service.title}
              </h3>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>

              <ul className="space-y-3">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start">
                    <i className="ri-check-line text-lg mr-3 mt-0.5 flex-shrink-0" style={{ color: '#98b8c1' }}></i>
                    <span className="text-gray-700 text-sm leading-relaxed">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}